/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type IGetBrazeAuthJwtQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IGetBrazeAuthJwtQuery = {
  __typename?: 'Query';
  brazeAuthJwt: string;
};

export const GetBrazeAuthJwtDocument = gql`
  query GetBrazeAuthJwt {
    brazeAuthJwt
  }
`;
export type GetBrazeAuthJwtQueryResult = Apollo.QueryResult<
  IGetBrazeAuthJwtQuery,
  IGetBrazeAuthJwtQueryVariables
>;
